export const state = {
    profileInfo: {},
    GetPaymentMethods: [],
    tradingAccount: [],

    newsData: {},
    economicCalData: {},
    openTradeList: [],
    pendingOrderList: [],
    tradeHistoryList: [],
    rejectedTradeList: [],
    pendingTradeList: [],
    transactionHistory: [],
    accBalance: {},
    currencyPairs: [],
    priceShift: {},
    wsOrder: {},
    watchList: {},
    orderBook: {},
    providerList: {coinexx_demo: "Demo", coinexx_live: "Live"},
    accountList: {},
    profileData: {},
    wsStatus: 3,
    userSettings: {},
    activePriceAlert: [],
    triggeredPriceAlert: [],
    priceAlertNotification: [],
    portfolioData: {},
    rawObject:{},
    defaultWorkSpaceList : {
        'Watchlist' : {t:0, l:0,   w:260,  h:400, active:true,  max:false, name:"Watch list"},
        'chart'     : {t:0, l:265, w:800,  h:400, active:true,  max:false, name:"Charts"},
        'position'  : {t:0, l:0,   w:1065, h:242, active:false, max:false, name:"Position list"},
        'order'     : {t:0, l:0,   w:1065, h:242, active:false, max:false, name:"Order list"},
        'history'   : {t:0, l:0,   w:1065, h:242, active:false, max:false, name:"Trade History"},
        'trade_log' : {t:0, l:0,   w:1065, h:242, active:false, max:false, name:"Trade Log"},
        'news'      : {t:0, l:0,   w:300,  h:380, active:false, max:false, name:"News"},
        'buy_sell'  : {t:0, l:0,   w:300,  h:399, active:false, max:false, name:"Buy and Sell"},
        'eco_cal'   : {t:0, l:0,   w:300,  h:380, active:false, max:false, name:"Economic Calender"},
        'depth'     : {t:0, l:0,   w:280,  h:347, active:false, max:false, name:"Market Depth"},
        'alert'     : {t:0, l:0,   w:280,  h:380, active:false, max:false, name:"Price Alert"},
    },
    appTheme:false,
    chartCompany:false,
    technicalAnalysis:[],
    pivotData:{},
    configProvider : {},
    leadersList : [],
    allLeadersList:[],
    followersSetting:{},
    leadersFilter:{
        matrix:{
            'followers':'Most Copied',
            'winTradesPercent':'Highest Win Rate',
            'rorBasedRoi':'Max Total Profit',
        },
        instrumentList:{
            "FOREX":"Forex",
            "COMMODITIES":"Commodities",
            "INDICES":"Indices",
            "CRYPTOS_CFD":"Crypto",
        },
        timeFrameList:{
            '' : 'All Transactions',
            30 : 'Last 1 Month',
            90 : 'Last 3 Months',
            180 : 'Last 6 Months',
            365 : 'Last 1 year'
        },
        riskClass:{
            1:'green',
            2:'green',
            3:'orange',
            4:'red',
            5:'red',
        },
    },
    leaderDetail : { },
    profitChartData : {},
    performanceChartData:{},
    portfolioChartData:{},
    drawdownChartData:{},
    leaderTradeHistory : {},
    userEquityChartWithLeader : {},
    userCopytradingDetails : {}
}


// WEBPACK FOOTER //
// ./src/plugins/commonAll/provider/store-addons/state.js